export const DOCTOR_FEEDBACK_MILESTONES = [2, 10, 20];

function storageKey(doctorId) {
  return `doctor_feedback_milestones_${doctorId}`;
}

export function getShownFeedbackMilestones(doctorId) {
  if (!doctorId) return [];
  try {
    const raw = localStorage.getItem(storageKey(doctorId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function markFeedbackMilestoneShown(doctorId, milestone) {
  if (!doctorId || milestone == null) return;
  const shown = getShownFeedbackMilestones(doctorId);
  if (shown.includes(milestone)) return;
  localStorage.setItem(storageKey(doctorId), JSON.stringify([...shown, milestone]));
}

/** Returns the milestone to prompt, or null if none. */
export function maybeFeedbackMilestone(approvedCount, doctorId) {
  const count = Number(approvedCount);
  if (!DOCTOR_FEEDBACK_MILESTONES.includes(count)) return null;
  if (getShownFeedbackMilestones(doctorId).includes(count)) return null;
  return count;
}
